import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * getValEmail
 *
 * Check the format of the email address you are trying to register and whether it is already registered.
 *
 * @param email Email address you are trying to register.
 * @returns Check result.
 */

export const getValEmail = async (email: string) => {
  try {
    const resp = await axios.get(getAPIRoot(APIRoutes.get.valid_email), {
      params: {
        sonic_email: email,
      },
    });
    return resp;
  } catch (error) {
    return false;
  }
};
